import { SYS_COLOR_CANVAS_200_DARK, SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK, } from '@oneaudi/unified-web-alpha-common';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_COLOR_SURFACE_NEUTRAL_800_DARK, } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { dynamicStylingHelper, GetSafeColorDesignToken } from '../../utils/AlphaHelper';
export const EquipmentOverlayWrapper = styled.div `
  background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_COLOR_CANVAS_200_DARK)};
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;

  .equipment-filter-layer-header {
    position: fixed;
    top: 0;
    z-index: 4;
    background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_800_DARK, SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK)};
    backdrop-filter: blur(${GetSafeColorDesignToken('EQUIPMENT_OVERLAY_HEADER')});
  }

  .equipment-filter--mobile {
    margin-bottom: 88px;
  }
`;
export const LayerHeading = styled.div `
  margin-top: 74px;
`;
export const EquipmentFilterOverlayNavigationHeaderMobile = styled.div `
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-columns: 56px 1fr 56px;
  background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_800_DARK, SYS_COLOR_CANVAS_200_DARK)};
  border-width: 1px 0;
  width: 100%;
`;
export const EquipmentComponent = styled.div `
  /* Only the non-accordion filterGroup is laid out differently */
  > div > fieldset {
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: ${SYS_BREAKPOINT_LG}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .equipment-accordion > div > div {
    display: grid;
    column-gap: var(--spacing-relative-xl);

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: ${SYS_BREAKPOINT_XL}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .show-equipment-sub-heading-desktop {
    display: none;

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: block;
    }
  }

  .equipment-filter--mobile,
  .show-equipment-filter-overlay-button-mobile {
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: none;
    }
  }
  .equipment-filter--desktop {
    display: none;
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      display: grid;
    }
  }
`;
